import { makeAutoObservable, runInAction } from 'mobx';
import { history } from "../..";
import agent from '../api/agent';

import { SGTDepartamento, SGTDepartamentoFormValues } from '../models/SGTDepartamentos';

export default class SGTDepartamentoStore {

    SGTDepartamentoRegistry = new Map<string, SGTDepartamento>();

    selectedSGTDepartamento: SGTDepartamento | undefined = undefined;
    editMode = false;
    loading = false;
    loadingInitial = false;
    recarga = false
    condicion = false
 

    constructor() {
        makeAutoObservable(this)
    }

    get SGTDepartamentoByName() {
        return Array.from(this.SGTDepartamentoRegistry.values());
    }
    
    get groupedSGTDepartamentos() {
        return this.SGTDepartamentoRegistry
    }

    loadSGTDepartamentos = async () => {
        this.loadingInitial = true;
        try {
            const SGTDepartamentos = await agent.SGTDepartamentos.list();
            SGTDepartamentos.forEach(SGTDepartamento => {
                this.setSGTDepartamento(SGTDepartamento);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    loadSGTDepartamento = async (iddeparta: string) => {
        let SGTDepartamento = this.getSGTDepartamento(iddeparta);
        if (SGTDepartamento) {
            this.selectedSGTDepartamento = SGTDepartamento;
            return SGTDepartamento;
        } else {
            this.loadingInitial = true;
            try {
                SGTDepartamento =  await agent.SGTDepartamentos.details(iddeparta);
                this.setSGTDepartamento(SGTDepartamento);
                runInAction(() => {
                    this.selectedSGTDepartamento = SGTDepartamento;
                })
                this.setLoadingInitial(false);
                return SGTDepartamento;
       
            } catch (error) {
                this.setLoadingInitial(false);
                return SGTDepartamento;
            }
        }
    }
  
    private setSGTDepartamento = (SGTDepartamento: SGTDepartamento) => {
        
        this.SGTDepartamentoRegistry.set(SGTDepartamento.idDeparta, SGTDepartamento);
    }

    private getSGTDepartamento = (iddeparta: string) => {
        return this.SGTDepartamentoRegistry.get(iddeparta);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }




   


}